import React from 'react';
import { logError } from '../../utils/analytics';
import './style.css';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Log error using our analytics utility
    logError('ErrorBoundary', error, {
      componentStack: errorInfo.componentStack,
      userAgent: navigator.userAgent,
      url: window.location.href
    });
  }

  render() {
  if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <h2>Something went wrong</h2>
          <p>We've been notified about this issue and are working to fix it.</p>
          <div className="error-boundary-actions">
            <button 
              onClick={() => window.location.reload()}
              className="error-boundary-button error-boundary-button-primary"
            >
              Reload Page
            </button>
            <button 
              onClick={() => this.setState({ hasError: false })}
              className="error-boundary-button error-boundary-button-secondary"
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 